
import { React } from 'react'
import styles from "../../styles.module.css"
import { GridProdutosServicos } from '../GridProdutosServicos'

export function ModalDetalhes(props) {
    if (props.registro.length <= 0) {
        return null
    }
    return (
        <div className={`${styles.modal}`}>
            <div className={`${styles.divAnimation}  flex flex-col w-full h-fit bg-white-200 rounded-xl overflow-hidden shadow-lg`} >
                <div class="flex items-center justify-between p-5 border-b rounded-t bg-gradient-to-r from-slate-900 to-slate-700 dark:border-gray-600">
                    <h3 class="text-xl font-medium text-white-200 dark:text-white">
                        Itens do Registro Nº <strong className='underline' >{props.registro?.CodigoRegistro}</strong>
                    </h3>


                    <button onClick={() => props.setCodigoRegistroSelecionado([])} type="button" class="text-white-200 bg-transparent hover:bg-red-500 hover:text-gray-100 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center dark:hover:bg-red-500 dark:hover:text-white" data-modal-hide="small-modal">
                        <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                        </svg>
                        <span class="sr-only">Close modal</span>
                    </button>
                </div>

                <div className=' relative p-2 h-full'>
                    <GridProdutosServicos
                        RegistrosProdutos={props.RegistrosProdutos.filter(c => c.CodigoRegistro == props.registro?.CodigoRegistro)}
                        CodigoRegistro={props.registro?.CodigoRegistro}
                    />
                </div>


            </div>
        </div>
    )
}
